import * as ActionConfigurationManager from './config.actions';

export const resetSession = ActionConfigurationManager.RESET_SESSION
export const sessionEnded = ActionConfigurationManager.SESSION_ENDED